import * as bootstrap from 'bootstrap';

export class Toast {
  static success(title, message, time = 5000) {
    $('#toast-nav .toast-header').removeClass('toast-error');
    $('#toast-nav .toast-header').addClass('toast-success');
    Toast.display(title, message, time, 'polite', 'status');
  }

  static error(title, message, time = 5000) {
    $('#toast-nav .toast-header').removeClass('toast-success');
    $('#toast-nav .toast-header').addClass('toast-error');
    Toast.display(title, message, time, 'assertive', 'alert');
  }

  static display(title, message, time = 5000, politeness = 'polite', alertType = 'alert') {
    const element = document.querySelector('#toast-nav .toast');
    if (!element) return;

    $('#toast-nav-title').html(title);
    $('#toast-nav-message').html(message);
    element.setAttribute('aria-live', politeness);
    element.setAttribute('role', alertType);

    // Bootstrap reads its options only when the instance is created, so a fresh instance is the
    // only way to apply a different delay to the shared toast element.
    bootstrap.Toast.getInstance(element)?.dispose();
    new bootstrap.Toast(element, { delay: time }).show();
  }
}
